export function compactNumber(num, toFixed = 0) {
  if (num >= 1e6) return `${(num / 1e6).toFixed(toFixed)}m+`;
  if (num >= 1e3) return `${(num / 1e3).toFixed(toFixed)}k+`;
  return String(num);
}
